import { analyzeJumpDestinations } from "./analyzeJumpDestinations.js";

/**
 * Check if a position is a valid JUMPDEST
 *
 * @param {import('./BytecodeType.js').BrandedBytecode} code - Bytecode to check
 * @param {number} position - Position to check
 * @returns {boolean} true if position is a valid JUMPDEST
 *
 * @example
 * ```typescript
 * const code = new Uint8Array([0x5b, 0x60, 0x5b, 0x5b]);
 * Bytecode.isValidJumpDest(code, 0); // true
 * Bytecode.isValidJumpDest(code, 2); // false (inside PUSH data)
 * Bytecode.isValidJumpDest(code, 3); // true
 * ```
 */
export function isValidJumpDest(code, position) {
	const validJumpdests = analyzeJumpDestinations(code);
	return validJumpdests.has(position);
}
